import { render, staticRenderFns } from "./NoHealingEffects.vue?vue&type=template&id=05459d22&scoped=true"
import script from "./NoHealingEffects.vue?vue&type=script&lang=js"
export * from "./NoHealingEffects.vue?vue&type=script&lang=js"
import style0 from "./NoHealingEffects.vue?vue&type=style&index=0&id=05459d22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05459d22",
  null
  
)

export default component.exports